import $ from "jquery";
import State from "../modules/state";
import {DEFAULT_STATE} from "./config";
const $eventhub = $(document);
const state = new State(DEFAULT_STATE, $eventhub);
const events = state.getEvents();
const store = {
	$eventhub,
	state,
	events
};

export default store;

//TODO delete
// DEBUG用のため本番UP時には削除したほうがよい
// npm run lint が通るなら誤ってglobalのstoreをしている箇所はないはずだが、
// 念の為要動作確認
window.store = store;



// WEBPACK FOOTER //
// ./web/WEB-INF/js/client/search/store.js